<!--
 * @Description  : 新增、编辑、查看文库管理
 * @Author       : wuxuebing
 * @Date         : 2024-09-25 10:32:08
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2026-01-14 14:13:42
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-management\components\add-dialog.vue
-->
<template>
	<div>
		<el-dialog
			:title="dialogObj.title"
			v-if="dialogObj.visible"
			:visible.sync="dialogObj.visible"
			width="1000px"
			max-height="600px"
			:close-on-click-modal="false"
			@close="handleClose"
		>
			<template v-if="dialogObj.visible">
				<Panel title="#1 创建人信息" :expand="false">
					<el-form class="tableForm" ref="userForm" size="small" :model="userForm" label-width="160px">
						<el-form-item label="发起人" prop="createUser" required>
							<el-input v-model="userForm.createUser" disabled></el-input>
						</el-form-item>
					</el-form>
				</Panel>

				<Panel title="#2 文档信息">
					<el-form
						:model="fileForm"
						:rules="fileFormRules"
						label-width="160px"
						ref="fileForm"
						size="small"
						:disabled="dialogObj.mode == 'view'"
					>
						<el-form-item label="类别" prop="classType" required>
							<el-radio-group v-model="fileForm.classType" :disabled="dialogObj.mode == 'view'">
								<el-radio :label="0">政策法规类</el-radio>
								<el-radio :label="1">标准图集类</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="标题" prop="title" required>
							<el-input
								:disabled="dialogObj.mode == 'view'"
								v-model="fileForm.title"
								placeholder="请输入"
								:maxlength="100"
								show-word-limit
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="是否启用" prop="status" required>
							<el-radio-group v-model="fileForm.status" :disabled="dialogObj.mode == 'view'">
								<el-radio :label="1">启用</el-radio>
								<el-radio :label="0">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="文库类型" prop="docType" required>
							<el-select v-model="fileForm.docType" clearable :disabled="dialogObj.mode == 'view'">
								<el-option
									v-for="(item, index) in projectDict.zsklx"
									:key="'docType' + index"
									:label="item.sname"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<!-- 标准图集展示 -->
						<template v-if="fileForm.classType == 1">
							<el-form-item label="标准（图集）号" prop="annulNo">
								<el-input v-model="fileForm.annulNo" placeholder="请输入" :maxlength="200" show-word-limit clearable></el-input>
							</el-form-item>
							<el-form-item label="标准类型" prop="normType">
								<el-select v-model="fileForm.normType" placeholder="请选择" clearable>
									<el-option
										v-for="(item, index) in projectDict.bzlx"
										:key="'normType' + index"
										:label="item.sname"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="省区" prop="province" v-if="fileForm.normType == '1001036003'">
								<el-input v-model="fileForm.province" placeholder="请输入" :maxlength="50" show-word-limit clearable></el-input>
							</el-form-item>
							<el-form-item label="执行标准" prop="exeNorm">
								<el-select v-model="fileForm.exeNorm" clearable>
									<el-option
										v-for="(item, index) in projectDict.zxbz"
										:key="'exeNorm' + index"
										:label="item.sname"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="ICS分类" prop="icsType">
								<el-select v-model="fileForm.icsType" clearable>
									<el-option
										v-for="(item, index) in projectDict.icsfl"
										:key="'icsType' + index"
										:label="item.sname"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="主管单位" prop="chargeUnit">
								<el-input v-model="fileForm.chargeUnit" placeholder="请输入" :maxlength="50" show-word-limit clearable></el-input>
							</el-form-item>
						</template>
						<el-form-item label="法律效力位阶" prop="lawRank">
							<el-select v-model="fileForm.lawRank" placeholder="请选择" clearable :disabled="dialogObj.mode == 'view'">
								<el-option
									v-for="(item, index) in projectDict.flxlwj"
									:key="'lawRank' + index"
									:label="item.sname"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="颁布机关" prop="issueUnit">
							<el-input
								v-model="fileForm.issueUnit"
								placeholder="请输入"
								:maxlength="200"
								show-word-limit
								clearable
								:disabled="dialogObj.mode == 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="文号" prop="referNo">
							<el-input
								v-model="fileForm.referNo"
								placeholder="请输入"
								:maxlength="50"
								show-word-limit
								clearable
								:disabled="dialogObj.mode == 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="适用范围">
							<el-select v-model="fileForm.applyRange" placeholder="请选择" clearable :disabled="dialogObj.mode == 'view'">
								<el-option
									v-for="(item, index) in projectDict.zsksyfw"
									:key="'applyRange' + index"
									:label="item.sname"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时效性" prop="efficientName" v-if="dialogObj.mode == 'view'">
							<el-input v-model="fileForm.efficientName" disabled></el-input>
						</el-form-item>
						<el-form-item label="公示日期" prop="releaseDate">
							<el-date-picker
								value-format="yyyy-MM-dd"
								v-model="fileForm.releaseDate"
								type="date"
								clearable
								:disabled="dialogObj.mode == 'view'"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="施行日期" prop="applyDate">
							<el-date-picker
								value-format="yyyy-MM-dd"
								v-model="fileForm.applyDate"
								type="date"
								clearable
								:disabled="dialogObj.mode == 'view'"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="废止日期" prop="annulDate">
							<el-date-picker
								value-format="yyyy-MM-dd"
								v-model="fileForm.annulDate"
								type="date"
								clearable
								:disabled="dialogObj.mode == 'view'"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="网址" prop="website">
							<el-input
								v-model="fileForm.website"
								placeholder="请输入"
								:maxlength="200"
								show-word-limit
								clearable
								:disabled="dialogObj.mode == 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="查看权限" prop="viewLimit" required>
							<el-select v-model="fileForm.viewLimit" placeholder="请选择" clearable :disabled="dialogObj.mode == 'view'">
								<el-option
									v-for="(item, index) in viewLimitList"
									:key="'viewLimit' + index"
									:label="item.sname"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="正文文档" prop="attachment">
							<public-upload
								:isDisabled="dialogObj.mode == 'view'"
								ref="enclosure"
								width="700px"
								:aid="attachmentAid"
								listType="text"
								tableName="lib_doc_manage"
								assortment="doc_manage_file"
								:acceptType="[]"
								:maxNum="1"
								:fileSize="99999999"
								@saveFileGetDataParams="fileHandle"
								@deleteFileGetDataParams="deleteFileHandle"
							></public-upload>
						</el-form-item>
						<el-form-item label="正文下载属性" prop="isDownload">
							<el-radio-group v-model="fileForm.isDownload" :disabled="dialogObj.mode == 'view'">
								<el-radio :label="1">启用</el-radio>
								<el-radio :label="0">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
				</Panel>

				<Panel title="#3 关键内容">
					<!-- 富文本 -->
					<wang-editor v-model="editForm.mainContent" ref="wangEditor" :isViewMode="dialogObj.mode == 'view'" :maxLength="5000"></wang-editor>
				</Panel>

				<!-- 当文档下载属性为 允许时，才展示 相关附件这个tabs -->
				<Panel title="#4 相关附件">
					<div class="file-table mt20">
						<div class="btn-style" v-if="dialogObj.mode !== 'view'">
							<el-upload
								class="upload-demo"
								action="customize"
								:multiple="false"
								:file-list="fileList"
								:http-request="uploadFile"
								ref="upload"
								list-type="text"
								:data="uploadParams.params"
								:show-file-list="false"
								:limit="options.limit"
								:before-upload="onBeforeUpload"
								:auto-upload="options.autoUpload"
								@success="clearFiles"
								@exceed="clearFiles"
							>
								<el-button size="small" type="primary" :loading="uploading">
									上传
								</el-button>
							</el-upload>
						</div>

						<!-- 上传附件表格 -->
						<vxe-table
							border
							resizable
							class="mt10 Ltable"
							show-overflow
							ref="filesData"
							max-height="500px"
							highlight-current-row
							:data="filesData"
							show-header-overflow="tooltip"
						>
							<vxe-column type="seq" width="60" align="center" title="序号"></vxe-column>
							<!-- 删除操作，详情页面隐藏删除按钮 -->
							<vxe-column title="操作" width="120">
								<template #default="{ row }">
									<el-button
										type="text"
										class="table-operation-icon"
										@click="handleChangeFile(row, '0')"
										v-if="dialogObj.mode !== 'view'"
									>
										<svg-icon icon-class="yichu"></svg-icon>
									</el-button>
									<el-button type="text" class="table-operation-icon" @click="handleFile(row, 'download')">
										<i class="el-icon-download"></i>
									</el-button>
								</template>
							</vxe-column>

							<vxe-column field="fileName" title="文档名称" min-width="200">
								<template #default="{ row }">
									<span class="link-class" @click="handleFile(row, 'view')">
										{{ row.fileName }}
									</span>
								</template>
							</vxe-column>

							<!-- 下载属性，详情页面该列禁用 -->
							<vxe-column title="下载属性" min-width="80">
								<template #default="{ row }">
									<vxe-switch
										class="ml10"
										v-model="row.isDownload"
										open-label="启用"
										close-label="禁用"
										:open-value="1"
										:close-value="0"
										@change="handleChangeFile(row, '1')"
										:disabled="dialogObj.mode == 'view'"
									></vxe-switch>
								</template>
							</vxe-column>

							<vxe-column field="createUser" title="上传人" min-width="80"> </vxe-column>
							<vxe-column field="createDate" title="上传时间" min-width="100"> </vxe-column>
						</vxe-table>
					</div>
				</Panel>

				<Panel title="#5 分类信息">
					<el-form ref="sortForm" :model="sortForm" label-position="left" :rules="sortRules" label-width="100px">
						<el-form-item label="所属分类：" prop="type">
							<el-tree
								class="mt10"
								ref="xTree"
								node-key="id"
								:props="{
									label: 'sname'
								}"
								:data="treeData"
								show-checkbox
								:check-on-click-node="true"
								default-expand-all
								:expand-on-click-node="false"
								:default-checked-keys="defaultChecked"
								@check-change="checkChange"
							></el-tree>
						</el-form-item>
					</el-form>

					<!-- 选中表格 -->
					<div class="select-table mt20">
						<div class="mb10">已选分类</div>

						<!-- 已选分类表格 -->
						<vxe-table
							border
							resizable
							class="mt10 Ltable"
							show-overflow
							ref="selectedData"
							max-height="300px"
							highlight-hover-row
							highlight-current-row
							:data="selectedData"
							show-header-overflow="tooltip"
						>
							<vxe-column type="seq" width="60" align="center" title="序号"></vxe-column>
							<!-- 删除操作，详情页面隐藏删除按钮 -->
							<vxe-column title="操作" width="80" align="center" v-if="dialogObj.mode !== 'view'">
								<template #default="{ row, rowIndex }">
									<svg-icon
										icon-class="yichu"
										class="svg-style"
										:class="row.status == 0 ? '' : 'del-style'"
										@click="deleteSelect(row, rowIndex)"
									></svg-icon>
								</template>
							</vxe-column>

							<vxe-column field="fullName" title="所属类型" min-width="100"> </vxe-column>
						</vxe-table>
					</div>
				</Panel>
				<!-- 底部按钮 -->
				<div slot="footer" class="dialog-footer text-center">
					<el-button @click="handleClose"> 取 消 </el-button>
					<el-button type="primary" :loading="btnLoading" @click="handleSave" v-if="dialogObj.mode !== 'view'">确 定</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script>
// api
import * as managementApi from "@/api/modules/library/library-management/index.js";
import Panel from "components/panel/Panel";
import { Snowflake } from "node-snowflake";
import {mapState} from "vuex";
import XEUtils from "xe-utils";

export default {
	components: { Panel},
	data() {
		return {
			dialogObj: {
				//弹出框对象
				visible: false,
				title: '查档申请',
				mode: 'add'
			},
			btnLoading: false, // 按钮加载

			userForm: {
				createUser: '', //发起人
				createUserid: '', //发起人id
				createDate: '' //发起时间
			}, // 当前登录人信息

			// 文档表单
			fileForm: {
				id: '', // 文档id
				classType: 0, // (政策法规类:0；标准图集类:1
				title: '', // 标题
				status: 1, // 状态 0：禁用；1：启用
				lawRank: '', // 法律效率位阶码表
				docType: '', // 文档类型
				issueUnit: '', // 颁布机关
				referNo: '', // 文号
				applyRange: '', // 适用范围
				efficient: '', // 时效性
				efficientName: '', // 时效性
				releaseDate: '', // 公示日期
				applyDate: '', // 施行日期
				annulDate: '', // 废止日期
				website: '', // 网址
				newFlag: 0, //新增标识 0：新增 1：编辑
				viewLimit: 0, // 查看权限, 0：任何人，1：本企业成员
				isDownload: '', // 下载属性，0：禁用；1：允许
				// 图集类字段
				annulNo: '', //  标准（图集）号
				normType: '', //  标准类型 (码表)
				province: '', //  省份
				exeNorm: '', //  执行标准（码表）
				icsType: '', //   ICS分类 (码表)
				chargeUnit: '' //  主管单位
			},
			viewLimitList: [
				{ sname: '所有人', value: 0 },
				{ sname: '本企业成员', value: 1 }
			], //查看权限数组
			fileFormRules: {
				title: [
					{
						required: true,
						message: '请填写标题',
						trigger: ['blur', 'change']
					}
				],
				status: [
					{
						required: true,
						message: '请选择是否启用',
						trigger: ['blur', 'change']
					}
				],
				docType: [
					{
						required: true,
						message: '请选择文库类型',
						trigger: ['blur', 'change']
					}
				],
				applyRange: [
					{
						required: true,
						message: '请选择适用范围',
						trigger: ['blur', 'change']
					}
				],
				viewLimit: [
					{
						required: true,
						message: '请选择查看权限',
						trigger: ['blur', 'change']
					}
				]
			},

			// 关键内容富文本
			editForm: {
				mainContent: ''
			},

			// 分类表单
			sortForm: {
				type: '' // 所属分类
			},
			sortRules: {},

			defaultChecked: [], // 默认选中的节点
			selectedData: [], //已经选中的分类表格
			treeData: [], // 分类信息
			allTree: [], // 拼接全路径的数组
			selectedPaths: [], // 用于存储所选节点的全路径名称
			filesData: [], // 上传附件表格
			// 上传配置
			attachmentAid: '', // 正文文档 aid
			uploadParams: {
				params: {
					fileName: '', // 上传的文件名
					id: '' // 上传附带的额外参数
				}
			},
			options: {
				headers: {
					'Content-type': 'multipart/form-data'
				}, // 上传的请求头
				showFileList: false, // 是否显示已上传文件列表
				multiple: false, // 是否多选
				drag: false, // 是否启用拖拽上传
				accept: [], // 接收文件的类型
				// limit: 1, // 文件最大上传个数
				fileSize: 99999999, // 文件大小限制
				sizeType: 'MB' // 文件大小类型
			},
			fileList: [], // 文件列表
			uploading: false // 是否正在上传
		}
	},
	methods: {
		// 上传文件保存后调用AI文档解析
		fileHandle(data) {
			data.id = ''
			//v3.14版本优化
			console.log('121212212')
			managementApi.parseFile(data)
		},

		// 删除文件调用AI接口删除向量数据库
		deleteFileHandle(data) {
			//v3.14版本优化
			console.log('454545454')
			managementApi.deleteById(data)
		},
		/***************************** 弹框初始化 **************************/
		// 弹框初始化
		initDialog(row, type, data) {
			// 模式赋值
			this.dialogObj.mode = type

			// id赋值
			this.fileForm.id = row.id ? row.id : Snowflake.nextId()
			this.attachmentAid = this.fileForm.id // 正文文档 aid

			// 分类数深拷贝
			let list = JSON.parse(JSON.stringify(data))

			// 树结构数据处理
			this.treeData = XEUtils.mapTree(
				list,
				(x) => {
					if (this.dialogObj.mode == 'view' || x.status == 0) {
						x.disabled = true
					}
					return x
				},
				{ children: 'children' }
			)

			// 获取所有节点的全路径名称和id
			this.allTree = this.flattenTree(list)
			// 如果是新增
			if (this.dialogObj.mode == 'add') {
				this.userForm = {
					createUser: this.userInfo.sname,
					createUserid: this.userInfo.id,
					createDate: XEUtils.toDateString(new Date())
				}
				this.dialogObj.title = '新建文档'
			} else {
				this.dialogObj.title = type == 'view' ? '查看文库' : '编辑文库'
				this.handleDetail(row)
			}

			// 判断是否是查看弹框，是查看弹框，则表单禁用
			// this.formConfig.fileOptions.displayOnly = type == "view";
			this.dialogObj.visible = true
		},

		// 树拼接名称和id
		flattenTree(tree, parentName = '', parentId = '') {
			const result = []

			for (const node of tree) {
				// 拼接当前节点的全层级名称
				const fullName = `${parentName}${parentName ? '>' : ''}${node.sname}`
				// 拼接当前节点的全层级ID
				const fullId = `${parentId}${parentId ? ',' : ''}${node.id}`

				// 将当前节点的信息加入结果数组
				result.push({ fullName, fullId, ...node })

				// 如果当前节点有子节点，则递归处理子节点
				if (node.children && node.children.length > 0) {
					result.push(...this.flattenTree(node.children, fullName, fullId))
				}
			}

			return result
		},

		/********************   编辑回显数据   ********************/

		// 处理编辑接口
		handleDetail(data) {
			// 发起人信息赋值
			Object.keys(this.userForm).forEach((key) => {
				this.$set(this.userForm, key, data[key])
			})

			// 分类信息赋值
			Object.keys(this.fileForm).forEach((key) => {
				this.$set(this.fileForm, key, data[key])
			})

			// 选中节点id清空
			this.defaultChecked = []
			// 选中分类数据赋值
			data.type.map((item) => this.defaultChecked.push(item.value))

			// 附件文件列表赋值
			this.getDocFiles()

			// 富文本赋值
			this.editForm.mainContent = data.mainContent

			// 已选分类表格赋值
			this.selectedData = this.allTree.filter((item) => this.defaultChecked.includes(item.id))
		},

		// 表单事件集合
		handleChange({ eventName, value, data }) {},

		/**************************** 弹框保存与关闭 **************************/
		// 弹框保存
		handleSave() {
			let that = this
			that.btnLoading = true
			that.$refs.fileForm.validate((valid) => {
				if (valid) {
					let arr = []
					// 选中分类信息数据处理
					that.selectedData.map((item) => arr.push(item.fullId))
					// that.selectedData.map(item => arr.push(item.id)); // fullId 全路径id 包含所有父级id    id 仅包含 被选中的那一层的id
					that.fileForm.newFlag = this.dialogObj.mode == 'add' ? 0 : 1
					// 拼接分类id
					let relateTypes = arr.join(';')
					let mainContent = that.editForm.mainContent

					// 如果文档信息 -- 类别是政策法规，清除图集类字段信息
					if (that.fileForm.classType == 0) {
						that.fileForm.annulNo = ''
						that.fileForm.normType = ''
						that.fileForm.province = ''
						that.fileForm.exeNorm = ''
						that.fileForm.icsType = ''
						that.fileForm.chargeUnit = ''
					}

					// 保存参数
					let params = {
						...that.userForm,
						...that.fileForm,
						relateTypes,
						mainContent
					}
					params.userId = this.userInfo.id;
					that.btnLoading = false
					managementApi
						.saveDoc(params)
						.then((res) => {
							that.$message.success({ message: '保存成功!' })
							that.handleClose()
							that.btnLoading = false
						})
						.catch((err) => {
							that.btnLoading = false
						})
				} else {
					that.$message.warning('请完善文档信息！')
					that.btnLoading = false
				}
			})
		},

		//关闭后的回调
		handleClose() {
			// 重置所有数据
			Object.assign(this.$data, this.$options.data())
			this.filesData = []
			this.dialogObj.visible = false
			this.$emit('updateSearch')
		},

		/********************   分类信息   ********************/
		// 已选表格删除
		deleteSelect(row) {
			// 如果是禁用状态不允许删除
			if (row.status == 0) {
				return
			}
			this.$refs.xTree.setChecked(row.id, false)
		},
		// 树的选中和取消
		checkChange(data, checked, indeterminate) {
			// 先在已选中的数据中查找是否有该数据
			let _index = this.selectedData.findIndex((y) => y.id === data.id)

			// 如果是选中数据，则将数据添加到已选数据中
			if (checked) {
				// 在allTree中查找对应的节点
				const params = this.allTree.find((x) => x.id == data.id && !x.children && x.status == 1)

				// 如果找到了对应的节点，则将其添加到已选数据中
				_index === -1 && params ? this.selectedData.push(params) : ''
			} else if (!checked && _index !== -1) {
				// 如果是取消选中，则从已选数据中删除该数据
				this.selectedData.splice(_index, 1)
			}
		},

		/********************   相关附件   ********************/

		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.options.accept.length > 0) {
				if (this.options.accept.find((x) => x === curType || x === curType.toLowerCase())) {
					return true
				} else {
					setTimeout(() => {
						this.$message.warning({ message: '文件格式不对，请重新选择！' })
					}, 0)
					this.$emit('uploadError')
					return false
				}
			} else {
				return true
			}
		},

		// 判断是否包含表情
		isEmojiStr(substring) {
			for (let i = 0; i < substring.length; i++) {
				let hs = substring.charCodeAt(i)
				if (0xd800 <= hs && hs <= 0xdbff) {
					if (substring.length > 1) {
						let ls = substring.charCodeAt(i + 1)
						let uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
						if (0x1d000 <= uc && uc <= 0x1f77f) {
							return true
						}
					}
				} else if (substring.length > 1) {
					let ls = substring.charCodeAt(i + 1)
					if (ls == 0x20e3) {
						return true
					}
				} else {
					if (0x2100 <= hs && hs <= 0x27ff) {
						return true
					} else if (0x2b05 <= hs && hs <= 0x2b07) {
						return true
					} else if (0x2934 <= hs && hs <= 0x2935) {
						return true
					} else if (0x3297 <= hs && hs <= 0x3299) {
						return true
					} else if (
						hs == 0xa9 ||
						hs == 0xae ||
						hs == 0x303d ||
						hs == 0x3030 ||
						hs == 0x2b55 ||
						hs == 0x2b1c ||
						hs == 0x2b1b ||
						hs == 0x2b50
					) {
						return true
					}
				}
			}
		},

		// 名称过滤掉特殊字符
		filterStr(str) {
			// ['`', '~', '!', '@', '#', '$', '%', '^', '&', '+', ';', ' ']
			let pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
			let specialStr = ''
			for (let i = 0; i < str.length; i++) {
				specialStr += str.substr(i, 1).replace(pattern, '')
			}
			return specialStr
		},

		// 上传前的判断处理
		onBeforeUpload(file) {
			// 判断文件名是否包含表情
			if (this.isEmojiStr(file.name)) {
				this.$message.warning({ message: '文件名包含表情，请修改后提交！' })
				this.$emit('uploadError')
				return false
			}
			// 大小判断
			if (this.options.sizeType == 'MB') {
				if (file.size / 1024 / 1024 > this.options.fileSize) {
					setTimeout(() => {
						this.$message.warning({
							message: `温馨提示：上传文件大小不能超过${this.options.fileSize} MB`
						})
					}, 0)
					this.$emit('uploadError')
					return false
				}
			} else if (this.options.sizeType === 'G') {
				if (file.size / 1024 / 1024 / 1024 > this.options.fileSize) {
					setTimeout(() => {
						this.$Modal.message.warning({
							message: `温馨提示：上传文件大小不能超过${this.options.fileSize} G`
						})
					}, 0)
					this.$emit('uploadError')
					return false
				}
			} else {
				if (file.size / 1024 > this.options.fileSize) {
					setTimeout(() => {
						this.$message.warning({
							message: `温馨提示：当前上传要求文件大小不能超过${this.options.fileSize} KB`
						})
					}, 0)
					this.$emit('uploadError')
					return false
				}
			}
			// 检查格式
			let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
			if (!this.checkType(curType)) {
				this.$emit('uploadError')
				return false
			}
			// 开始上传
			this.uploading = true
			return true
		},

		// 上传文件操作
		uploadFile(params) {
			this.uploading = true
			const _file = params.file
			// 过滤特殊字符
			let nameArr = params.file.name.split('.')
			let suffix = nameArr[nameArr.length - 1]
			let _name = `${this.$SnowFlake.nextId()}_${this.$generateRandomString()}.${suffix}`

			// id赋值
			let fileId = this.attachmentAid

			let formData = new FormData()
			formData.append('file', _file)
			formData.append('id', fileId) // 附件id
			formData.append('filename', params.file.name) // 附件名称
			formData.append('serverName', _name) // 附件名称

			// 解析文件
			managementApi
				.saveDocFile(formData)
				.then((res) => {
					// 如果上传成功，则调取附件接口
					if (res.code == 0) {
						this.$message.success({ message: '上传成功！' })
						this.getDocFiles() // 附件文件列表赋值
					}
					this.uploading = false
				})
				.catch(() => {
					this.uploading = false
					this.clearFiles()
				})
		},

		// 清除文件
		clearFiles() {
			this.$refs.upload.clearFiles() // 清除文件
		},

		// 附件列表
		getDocFiles() {
			managementApi.getDocFiles({ id: this.attachmentAid }).then((res) => {
				// 附件文件列表赋值
				this.filesData = res.data
			})
		},

		// 删除文件、切换下载属性
		handleChangeFile(row, type) {
			// 调用接口
			let params = {
				id: row.fileId, // 文件id
				type // 修改类型 0: 删除 1：下载属性
			}
			managementApi.updateDocFileStatus(params).then((res) => {
				this.$message.success({ message: '操作成功！' })
				this.getDocFiles() // 附件文件列表赋值
			})
		},

		// 预览附件、下载附件
		handleFile(row, type) {
			switch (type) {
				case 'download':
					console.log(row.fileName)
					this.$downloadFile(row.filePath, row.fileName)
					break
				case 'view':
					this.$previewFn(row.filePath, row.fileName)
					break
			}
		},

		// 检查文件格式 是否为图片
		isPicture(file) {
			let picArr = ['JPG', 'JPEG', 'PNG', 'GIF', 'SVG', 'BMP'] //列举所有可查看后缀
			let fileTypeArr = file.fileSuffix ? file.fileSuffix : '' //判断有无后缀
			let fileType = fileTypeArr.toUpperCase() //都转成大写
			return picArr.includes(fileType)
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		// 文档类型 word/excel,ppt
		fileTypeArr() {
			return [
				{ fileSuffix: ['doc', 'docx'], name: 'word', value: 1 },
				{ fileSuffix: ['xlsx', 'xls'], name: 'excel', value: 2 },
				{ fileSuffix: ['ppt', 'pptx'], name: 'ppt', value: 3 }
			]
		}
	},
	watch: {}
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
	padding: 10px 30px;
	max-height: 68vh;
	overflow-y: auto;
	font-size: 14px;
}

.del-style {
	color: red !important;
	cursor: pointer !important;
}

.svg-style {
	cursor: not-allowed;
	font-size: 24px;
	padding-left: 5px;
}

.link-class {
	color: #3ba1ff;
	cursor: pointer;
}

// 上传文件样式
.file-table {
	.btn-style {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
}

/deep/ .vxe-table--render-default.vxe-editable .vxe-body--column {
	height: 40px;
	border: 1px solid red;
}
</style>
